/* eslint-disable jsx-a11y/alt-text */
import React, { Component, Fragment } from 'react';
import { shopContext } from '../../contexts/aniplus';
import { withRouter } from 'react-router-dom';

const Evednt202509_kaiju_popup = (props) => {
  const { imgUrl } = props;
  const _onBack = () => {};
  return (
    <Fragment>
      <div className="event_head">
        <h3>괴수 8호 팝어 스토어</h3>
        <button
          type="button"
          className="btnClose"
          onClick={_onBack}
          style={{ pointer: 'cursor' }}
        >
          <img src="/img/detail_img/close_1.png" alt="닫기" />
        </button>
      </div>
      <div className="eventCon">
        <Fragment>
          <img
            src={imgUrl + '/img/event/event202509_kaiju/img_1.png'}
            useMap="#image-map"
          />
          <map name="image-map">
            <area
              target="_blank"
              alt="오시는길"
              title="오시는길"
              href="https://www.akplaza.com/store/introduce?store=51"
              coords="425,2594,794,2679"
              shape="rect"
            />
          </map>
        </Fragment>
      </div>
    </Fragment>
  );
};

export default shopContext(withRouter(Evednt202509_kaiju_popup));
